var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "btn_group" }, [
    _c(
      "button",
      {
        attrs: { title: "添加事件", tabindex: "-1" },
        on: { click: _vm.add_item }
      },
      [_vm._v("+")]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        attrs: { title: "删除当前", tabindex: "-1" },
        on: { click: _vm.remove_item }
      },
      [_vm._v("-")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }